// Shown when PrimeChart is embedded in an iframe WITHOUT a hospital slug.
// We don't run the all-hospitals picker inside a partner's page — an embed must
// target one hospital (…/hospital?slug=<slug>).
function EmbedNeedsSlug() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="max-w-md text-center">
        <div className="text-4xl mb-3">🏥</div>
        <h1 className="text-lg font-semibold text-gray-800 mb-2">
          Hospital link required
        </h1>
        <p className="text-sm text-gray-600">
          This booking widget needs a hospital. Embed it with a hospital link, e.g.
        </p>
        <code className="mt-3 inline-block bg-gray-100 text-gray-700 text-xs px-3 py-2 rounded-lg break-all">
          https://primechart.et/hospital?slug=&lt;your-hospital&gt;
        </code>
      </div>
    </div>
  );
}

export default EmbedNeedsSlug;
